import LocationHours from './LocationHours.view';

export default LocationHours;
